import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';
import {
  getProfileOwnerUser,
  getProfileOwnerStat,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';
import { getUsersByIds } from '@wix/da-shared-react/pkg/redux/users/selectors';
import { ModuleType } from '../../../../types/modules';

export const containerCreator = (streamType, streamId) =>
  connect(
    (state: AppState) => {
      const type = streamType;
      const totalCount = getProfileOwnerStat(state, type);
      const deviants = getUsersByIds(
        state,
        streamSelectors.getItems(state, streamId)
      );
      const hasMore = streamSelectors.hasMore(state, streamId);
      const isFetching = streamSelectors.isFetching(state, streamId);
      return {
        type,
        profileOwnerUser: getProfileOwnerUser(state),
        deviants,
        hasMore,
        isFetching,
        totalCount,
        isOwner: isCurrentUserProfileOwner(state),
        isEmpty: !deviants || !deviants.length,
        canSeeAll: streamSelectors.getStreamParam(state, streamId, 'canSeeAll'),
        withConifg: [
          ModuleType.WATCHERS,
          ModuleType.GROUP_MEMBERS,
          ModuleType.ACTIVE_MEMBERS,
        ].includes(streamType),
      };
    },
    dispatch => ({
      fetchMore: () => dispatch(withOffset.actions.fetch(streamId)),
    })
  );
